export const KonfigurasiLogos = [
  {
    image: "/image/logoUmkm2.webp",
  },
  {
    image: "/image/logoUmkm1.webp",
  },
  {
    image: "/image/logoUmkm4.webp",
  },
  {
    image: "/image/logoUmkm5.webp",
  },
  {
    image: "/image/logoUmkm6.webp",
  },
  {
    image: "/image/logoUmkm7.webp",
  },
];

export const FilosofiLogos = [
  {
    no: 1,
    image: "/image/logoFilosofi1.webp",
    title: "Lilin Penerang",
    description:
      "Lilin kecil dengan cahaya besar adalah representasi kosmologis usaha mikro, kecil, dan menengah (UMKM) yang walaupun berskala kecil namun memiliki peran dan dampak yang signifikan bagi perekonomian Indonesia.",
  },
  {
    no: 2,
    image: "/image/logoFilosofi2.webp",
    title: "Panah Kembar",
    description:
      "Representasi semangat Back To The Future yaitu semangat tumbuh melesat ke atas dengan berani berinovasi, menghargai masa lalu dan menatap ke masa depan.",
  },
  {
    no: 3,
    image: "/image/logoFilosofi3.webp",
    title: "Suar Abadi",
    description:
      "Representasi semangat kewirausahaan yang mampu menghadapi berbagai tantangan dan menciptakan banyak peluang.",
  },
  {
    no: 4,
    image: "/image/logoFilosofi4.webp",
    title: "Roda Cahaya",
    description:
      "Representasi siklus usaha yang terus berputar dan berkembang menciptakan ekosistem usaha yang berdampak luas dan berkelanjutan.",
  },
];

export const NilaiLogos = [
  {
    image: "/image/logoNilai1.webp",
    title: "Berani",
    description: "Adaptif, Gigih, Risk Taker, Gotong Royong",
  },
  {
    image: "/image/logoNilai2.webp",
    title: "Visioner",
    description: "Inovatif, Progresif, Dinamis, Optimis",
  },
  {
    image: "/image/logoNilai3.webp",
    title: "Berdampak",
    description: "Bermanfaat, Inspiratif, Humanis, Peduli",
  },
];

export const WarnaLogos = [
  {
    title: "Infinity Blue",
    image: "/image/imageWarnaLogo1.webp",
    description: (
      <>
        Warna Infinity Blue mencerminkan semangat UMKM yang{" "}
        <span className="font-bold text-cust-blue">adaptif</span> dan{" "}
        <span className="font-bold text-cust-blue">inovatif</span> membuat UMKM Indonesia mampu
        bertahan dan tumbuh ke atas, menghadapi setiap tantangan.
      </>
    ),
    hexCodes: ["#22466C", "#2B6685", "#4788AB", "#6397B1"],
    direction: "left",
  },
  {
    title: "Golden Flake",
    image: "/image/imageWarnaLogo2.webp",
    description: (
      <>
        Warna Gold Flake mencerminkan semangat untuk berdampak, untuk{" "}
        <span className="font-bold text-cust-blue">kejayaan</span> dan UMKM yang membawa{" "}
        <span className="font-bold text-cust-blue">kemakmuran</span> dan bagi masyarakat Indonesia
        dan membuka pintu menuju Indonesia Emas.{" "}
      </>
    ),
    hexCodes: ["#BC9313", "#D8B049", "#F1D48E", "#F6E2AC"],
    direction: "right",
  },
];
